/* dropdown-item YWC — DEV-16505 — data-carrier, no visual rendering */
class YalwaDropdownItem extends HTMLElement {

	static get observedAttributes() {
		return ['label', 'description', 'value', 'appearance', 'selected', 'disabled', 'divider'];
	}

	constructor() {
		super();
		this.item_state = {
			label: null,
			description: null,
			value: null,
			appearance: 'simple',
			selected: false,
			disabled: false,
			divider: false,
		};
	}

	connectedCallback() {
		this.sync_state();
	}

	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value) {
			this.sync_state();
		}
	}

	sync_state() {
		this.item_state.label = this.getAttribute('label');
		this.item_state.description = this.getAttribute('description');
		this.item_state.value = this.getAttribute('value');
		this.item_state.appearance = this.getAttribute('appearance') || 'simple';
		this.item_state.selected = this.hasAttribute('selected');
		this.item_state.disabled = this.hasAttribute('disabled');
		this.item_state.divider = this.hasAttribute('divider');
	}
}

customElements.define('yalwa-dropdown-item', YalwaDropdownItem);
